<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'汎用テキスト情報：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'汎用テキスト情報：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="addGeneralText()" [disabled]="!generalTextFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <form class="form" [formGroup]="generalTextFormGroup">
      <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">
        <mat-form-field>
          <mat-label floatLabel="always">ID</mat-label>
          <input matInput *ngIf="!isAdded" placeholder="ID" id="textId" formControlName="textId" readonly>
          <input matInput *ngIf="!!isAdded" placeholder="ID" id="textId" formControlName="textId">
          <mat-error *ngIf="textIdControl.invalid">{{ getErrorMessageToTextId() }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label floatLabel="always">{{'テキスト' | translate}}</mat-label>
          <input matInput placeholder="{{'テキスト' | translate}}" id="texts" value="{{ generalText!.texts | generalText:'ja' }}" readonly>
          <button matSuffix mat-stroked-button color="primary" (click)="openGeneralTextDialog()">
            <mat-icon>edit</mat-icon>
          </button>
          <mat-error *ngIf="textsControl.invalid">{{ getErrorMessageToTexts() }}</mat-error>
        </mat-form-field>
      </div>

    </form>
  </div>

</div>